import { useSelector } from "react-redux";
import { RootState } from "../store";
import { TAX_PAYER_SETTINGS_UPDATE } from "../auth/permissions";

export const useNotificationSettingsAccess = () => {
  const taxPayer = useSelector(
    (state: RootState) => state.taxPayer.data.taxPayer,
  );
  const permissions = useSelector(
    (state: RootState) => state.taxPayerPermissions,
  );
  const parameters = useSelector(
    (state: RootState) => state.taxPayerParameters,
  );
  const ready =
    taxPayer.id !== undefined &&
    permissions.loaded &&
    parameters.loaded &&
    permissions.taxPayerId === taxPayer.id &&
    parameters.taxPayerId === taxPayer.id;
  const allowed =
    ready && permissions.permissions.includes(TAX_PAYER_SETTINGS_UPDATE);
  return {
    taxPayer,
    ready,
    allowed,
    whatsappAllowed: allowed && parameters.data.whatsappEnabled === true,
  };
};
